import { Global } from '~/global'

export enum Permission {
    /* === ADMIN PERMISSIONS === */
    ADMIN_MODE = 'admin-mode', // Enable admin mode
    ADMIN_CONSOLE = 'admin-console',
    DLIST = 'dlist', // Create, view
    DLIST_EXPORT = 'dlist-export', // Excel export
    LOCAL_COMMUNITY = 'local-community', // Create
    TRANSFER_PORTAL = 'transfer-portal', // Approve
    ADMIN_SECURITY_DLIST = 'admin-security-dlist', // Create, disable admin users
    OFFICE = 'office', // Create, update, deactivate, delete
    USER = 'user', // See below...
    // - User admin fields (edit) e.g. holiday calendar for time off
    // - Time off (view, edit)
    // - Admin version of profile history (view)
    // - Inactive (Create, edit, view)
    // - External email profiles (edit)
    // - Import, export users
    // - Guest passes (create, revoke, renew)
    // - In memoriam (create)
    MANAGER_FEEDBACK_VIEW = 'manager-feedback-view',
    MANAGER_FEEDBACK_CONFIG = 'manager-feedback-config', // Start, end, reminders, edit
    TRANSFER_PORTAL_VIEW = 'transfer-portal-view',
    CHECKIN = 'checkin', // View outside mgmt chain in process, edit, delete, mark not required
    BOARD_CONTACT_DETAIL = 'board-contact-detail', // View board of directors contact info
    FEED = 'feed', // See below...
    // - Delete
    // - View while suspended
    // - Add @All mention
    // - Feed suspension edit
    CHECKIN_CONFIG = 'checkin-config', // Edit
    FEATURES = 'features', // See below...
    // - Features (edit)
    // - Profile features (edit)
    // - Email integration (edit)
    // - New Hires Email (edit)
    // - Roles (edit)
    // - Products (edit)
    SETTINGS = 'settings', // Branding, service accts, identity & security, IP access control, etc.
    GLOBAL_AUDIT = 'global-audit', // View (not including check in)
    GLOBAL_AUDIT_WITH_CHECKIN = 'global-audit-with-checkin', // View (including check in)
    REPORTING = 'reporting', // View
    NEW_HIRE_ANNOUNCEMENT_TESTING = 'new-hire-announcement-testing',
    SKILL_TAG_CREATION = 'skill-tag-creation',
    CUSTOMER = 'customer',
    POST = 'post', // Post and comment delete, view inactive
    SENIOR_ADMINISTRATOR = 'senior-administrator', // Add and remove senior administrators
    /* === USER PERMISSIONS === */
    USER_EDIT = 'user-edit',
    USER_TIMEOFF = 'user-timeoff', // View, add, edit, delete
    USER_POST = 'user-post', // Posts, comments, likes
    CUSTOMER_MEMBERS_VIEW = 'customer-members-view',
    CUSTOMER_ADD = 'customer-add', // Add / edit
    CUSTOMER_JOIN = 'customer-join',
    COMMUNITY_LOCAL_VIEW = 'communitiy-local-view',
    COMMUNITY_ADD = 'community-add',
    DLIST_ADD = 'dlist-add',
    DISTRIBUTION_LIST_JOIN = 'distribution-list-join', // SERVER ONLY
    GROUP_POST_VIEW = 'group-post-view', // SERVER ONLY
    VIEW_CHECKIN = 'view-checkin',
    CUSTOM_ONBOARDING_VIEW = 'custom-onboarding-view', // SERVER ONLY
}

export const authHasPermission = (permission: Permission | Set<Permission>) => {
    if (permission instanceof Set) {
        return permission.isSubsetOf(new Set(Global.OW_AUTH_DATA.permissions ?? []))
    }

    return Global.OW_AUTH_DATA.permissions?.includes(permission) || false
}
